class Wishlist {

    constructor() {

        this.wrapper = document.getElementById("WishlistProducts");

        this.empty = document.getElementById("WishlistEmpty");

        this.storageKey = "wishlist";

        this.init();

    }

    init() {

        this.updateWishlistCount();

        this.syncWishlistButtons();

        this.bindGlobalWishlistButtons();

        if (this.wrapper) {

            this.loadWishlist();

        }

    }

    /*=========================================
    =            LOCAL STORAGE               =
    =========================================*/

    getWishlist() {

        try {

            return JSON.parse(

                localStorage.getItem(this.storageKey)

            ) || [];

        }

        catch (error) {

            console.error(error);

            return [];

        }

    }

    saveWishlist(wishlist) {

        localStorage.setItem(

            this.storageKey,

            JSON.stringify(wishlist)

        );

    }

    /*=========================================
    =      GLOBAL HEART BUTTONS             =
    =========================================*/

    bindGlobalWishlistButtons() {

        document.addEventListener("click", e => {

            const button = e.target.closest(".wishlist-btn");

            if (!button) return;

            e.preventDefault();

            const handle = button.dataset.productHandle;

            this.toggleWishlist(handle);

        });

    }

    addWishlist(handle) {

        const wishlist = this.getWishlist();

        if (!wishlist.includes(handle)) {

            wishlist.push(handle);

            this.saveWishlist(wishlist);

        }

    }

    removeWishlist(handle) {

        const wishlist = this.getWishlist().filter(

            item => item !== handle

        );

        this.saveWishlist(wishlist);

    }

    hasWishlist(handle) {

        return this.getWishlist().includes(handle);

    }

    clearWishlist() {

        localStorage.removeItem(

            this.storageKey

        );

    }

    updateWishlistCount() {

        const count = this.getWishlist().length;

        document.querySelectorAll(

            ".wishlist-count"

        ).forEach(item => {

            item.textContent = count;

        });

    }

    /*=========================================
    =            LOAD WISHLIST               =
    =========================================*/

    async loadWishlist(){

        const wishlist=

        this.getWishlist();

        this.wrapper.innerHTML="";

        if(!wishlist.length){

            this.showEmpty();

            return;

        }

        this.hideEmpty();

        for(const handle of wishlist){

            await this.renderProduct(handle);

        }

        this.bindEvents();

        this.syncWishlistButtons();

        if(

            !this.wrapper.children.length

        ){

            this.showEmpty();

        }

    }

    clearWishlist(){

        localStorage.removeItem(

            this.storageKey

        );

        this.updateWishlistCount();

        this.syncWishlistButtons();

        this.loadWishlist();

    }

    formatMoney(cents){

        return new Intl.NumberFormat(

            "en-IN",

            {

                style:"currency",

                currency:"INR"

            }

        ).format(cents/100);

    }

    showEmpty() {

        if (this.empty) {

            this.empty.style.display = "block";

        }

    }

    hideEmpty() {

        if (this.empty) {

            this.empty.style.display = "none";

        }

    }

    /*=========================================
    =            PRODUCT LOADING            =
    =========================================*/

    async renderProduct(handle){

        try{

            const response=

            await fetch(

                `/products/${handle}.js`

            );

            if(!response.ok) return;

            const product=

            await response.json();

            if(!product.available){

                return;

            }

            this.wrapper.insertAdjacentHTML(

                "beforeend",

                this.card(product)

            );

        }

        catch(e){

            console.error(e);

        }

    }

    /*=========================================
    =            PRODUCT CARD               =
    =========================================*/

    card(product) {

        const image = product.featured_image
            ? product.featured_image
            : "";

        const comparePrice = product.compare_at_price || 0;

        const salePrice = product.price;

        let discount = 0;

        if (comparePrice > salePrice) {

            discount = Math.round(
                ((comparePrice - salePrice) * 100) /
                comparePrice
            );

        }

        return `

        <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-4">

            <div class="wishlist-card">

                <div class="wishlist-image">

                    <a href="${product.url}">

                        <img
                            src="${image}"
                            alt="${product.title}"
                            class="img-fluid"
                            loading="lazy"
                        >

                    </a>

                    ${discount > 0
                        ?
                        `<span class="wishlist-sale-badge">
                            -${discount}%
                        </span>`
                        :
                        ""
                    }

                </div>

                <div class="wishlist-content">

                    <h5 class="wishlist-title">

                        <a href="${product.url}">

                            ${product.title}

                        </a>

                    </h5>

                    <div class="wishlist-price">

                        <span class="sale-price">

                            ${this.formatMoney(salePrice)}

                        </span>

                        ${comparePrice > salePrice
                        ?
                        `<del>
                                ${this.formatMoney(comparePrice)}
                            </del>`
                        :
                        ""
                    }

                    </div>

                    <div class="wishlist-buttons">

                        <button
                            class="btn btn-dark add-cart"
                            data-variant="${product.variants[0].id}"
                        >

                            Add To Cart

                        </button>

                        <button
                            class="btn btn-outline-danger remove-wishlist"
                            data-handle="${product.handle}"
                        >

                            Remove

                        </button>

                    </div>

                </div>

            </div>

        </div>

        `;

    }

    destroy(){

        this.wrapper=null;

        this.empty=null;

    }

    /*=========================================
    =            MONEY FORMAT              =
    =========================================*/

    money(cents) {

        return new Intl.NumberFormat(

            "en-IN",

            {

                style: "currency",

                currency: "INR"

            }

        ).format(cents / 100);

    }

    /*=========================================
    =            EVENTS                      =
    =========================================*/

    bindEvents() {

        document.querySelectorAll(".remove-wishlist").forEach(button => {

            button.onclick = () => {

                this.removeWishlistItem(

                    button.dataset.handle

                );

            };

        });

        document.querySelectorAll(".add-cart").forEach(button => {

            button.onclick = () => {

                this.addToCart(

                    button.dataset.variant,

                    button

                );

            };

        });

    }

    /*=========================================
    =            REMOVE PRODUCT              =
    =========================================*/

    removeWishlistItem(handle) {

        this.removeWishlist(handle);

        this.updateWishlistCount();

        this.syncWishlistButtons();

        this.loadWishlist();

    }

    /*=========================================
    =            ADD TO CART                 =
    =========================================*/

    async addToCart(variantId, button) {

        if (!variantId) return;

        button.disabled = true;

        button.classList.add("loading");

        try {

            const response = await fetch("/cart/add.js", {

                method: "POST",

                headers: {

                    "Content-Type": "application/json",

                    "Accept": "application/json"

                },

                body: JSON.stringify({

                    id: variantId,

                    quantity: 1

                })

            });

            if (!response.ok) {

                throw await response.json();

            }

            await this.updateCart();

            button.classList.add("added");

            setTimeout(() => {

                button.classList.remove("added");

            },1500);

        }

        catch(error){

            console.error(error);

            alert(

                error.description ||

                "Unable to add product."

            );

        }

        finally{

            button.disabled=false;

            button.classList.remove("loading");

        }

    }

    /*=========================================
    =            UPDATE CART                 =
    =========================================*/

    async updateCart() {

        const response = await fetch("/cart.js");

        const cart = await response.json();

        this.updateCartCount(cart);

        await this.refreshCartDrawer();

    }

    /*=========================================
    =            CART COUNT                  =
    =========================================*/

    updateCartCount(cart) {

        document.querySelectorAll(

            ".cart-count, .header-cart-count"

        ).forEach(item => {

            item.textContent = cart.item_count;

        });

    }


    /*=========================================
    =            CART DRAWER                =
    =========================================*/

    async refreshCartDrawer() {

        try {

            const response = await fetch(

                "/?section_id=cart-drawer"

            );

            const html = await response.text();

            const parser = new DOMParser();

            const doc = parser.parseFromString(

                html,

                "text/html"

            );

            const newDrawer = doc.querySelector("#CartDrawer");

            const currentDrawer = document.querySelector("#CartDrawer");

            if (newDrawer && currentDrawer) {

                currentDrawer.innerHTML = newDrawer.innerHTML;

            }

            this.openCartDrawer();

        }

        catch (error) {

            console.error(error);

        }

    }


    /*=========================================
    =            OPEN DRAWER                =
    =========================================*/

    openCartDrawer() {

        const drawer = document.getElementById("CartDrawer");

        if (!drawer) return;

        const instance = bootstrap.Offcanvas.getOrCreateInstance(

            drawer

        );

        instance.show();

    }


    /*=========================================
    =            WISHLIST SYNC               =
    =========================================*/

    syncWishlistButtons() {

        document.querySelectorAll(".wishlist-btn").forEach(button => {

            const handle = button.dataset.productHandle;

            if (!handle) return;

            if (this.hasWishlist(handle)) {

                button.classList.add("active");

            } else {

                button.classList.remove("active");

            }

        });

    }

    /*=========================================
    =            TOGGLE WISHLIST            =
    =========================================*/

    toggleWishlist(handle) {

        if (!handle) return;

        if (this.hasWishlist(handle)) {

            this.removeWishlist(handle);

        } else {

            this.addWishlist(handle);

        }

        this.updateWishlistCount();

        this.syncWishlistButtons();

        if (this.wrapper) {

            this.loadWishlist();

        }

    }

}

document.addEventListener(

    "DOMContentLoaded",

    ()=>{

        window.wishlist=

        new Wishlist();

    }

);